export default {"src":"/_next/static/media/type-2.82cf712e.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};